import types from './types';

const getPhotosForMonthRequest = (month, year) => ({
  type: types.GET_CENTER_PHOTOS_MONTH_REQUEST,
  month,
  year
});

const getPhotosForMonthSuccess = (photos, month, year) => ({
  type: types.GET_CENTER_PHOTOS_MONTH_SUCCESS,
  photos,
  month,
  year
});

const getPhotosForMonthFailure = () => ({
  type: types.GET_CENTER_PHOTOS_MONTH_FAILURE
});

export default {
  getPhotosForMonthRequest,
  getPhotosForMonthSuccess,
  getPhotosForMonthFailure
};
